import {Wallet} from 'lucide-react'

function CurveGateCard({
  title,
  body,
  actionLabel,
  onAction,
  disabled = false,
}: {
  title: string
  body: string
  actionLabel: string
  onAction?: () => void
  disabled?: boolean
}) {
  return (
    <div className="rounded-2xl border border-lime-400/20 bg-lime-400/5 px-4 py-3">
      <p className="text-sm font-medium text-white">{title}</p>
      <p className="mt-1 text-xs leading-relaxed text-zinc-400">{body}</p>
      <button
        type="button"
        onClick={onAction}
        disabled={disabled || !onAction}
        className="mt-3 inline-flex items-center gap-2 rounded-full bg-lime-400 px-3.5 py-1.5 text-xs font-semibold text-black hover:opacity-90 disabled:cursor-wait disabled:opacity-60"
      >
        <Wallet className="h-3.5 w-3.5" aria-hidden="true" />
        {actionLabel}
      </button>
    </div>
  )
}

export default CurveGateCard
